// The transcript pop-up (30 Sep 2026): tapping "Working" in the header, or the open icon on an
// updates card, shows that request's live transcript in the Helpers-style sheet, scrollable.
import { createContext } from "react";
import { create } from "zustand";

interface TranscriptSheetState {
  /** A request message id, "latest" (the newest request in this chat), or null (closed). */
  target: string | null;
  open: (target: string) => void;
  close: () => void;
}

export const useTranscriptSheet = create<TranscriptSheetState>((set) => ({
  target: null,
  open: (target) => set({ target }),
  close: () => set({ target: null }),
}));

/** True inside the pop-up: cards render fully open, without their own toggle. */
export const TranscriptInSheet = createContext(false);
/** Set by an updates block in the chat: opens its request's transcript in the pop-up. */
export const TranscriptOpener = createContext<(() => void) | null>(null);

/** What the pop-up's title shows after "Transcript": the agent (Opus) and its state. The
 *  cards inside report it; the sheet header shows it once instead of a card title + pill. */
export const useSheetMeta = create<{ name: string; phase: string; active: boolean;
  report: (m: { name: string; phase: string; active: boolean }) => void }>((set) => ({
  name: "", phase: "", active: false,
  report: (m) => set(m),
}));
